<template>
  <div class="m-card">
    <div class="m-card__body">
      <div class="m-card__body-content">
        <a :href="data.url" :target="getTarget(data.url)"
           class="m-card__body-link">
          <img :src="data.logo" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LinkService from '@/services/LinkService'

export default {
  name: 'CardLogo',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    getTarget(link) {
      return LinkService.getTarget(link)
    }
  }
}
</script>

<style lang="scss" scoped>
$card-ratio: calc( 5/4 ) !default;

.m-card {
  overflow: hidden;
  width: 100%;
  color: #fff;
  border-radius: 0;

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &-link {
      background-repeat: no-repeat;
      background-position-x: center;
    }

    &-content {
      padding: 0 2.25rem;
      font-style: normal;
      font-stretch: normal;

      a {
        display: block;
        width: 100%;
      }

      img {
        display: block;
        margin: auto;
        width: 100%;
        height: auto;

        filter: grayscale(1);
      }
    }
  }

  &:hover {
    img {
      filter: grayscale(0);
    }
  }
}
</style>
